import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from './Components/Footer';
import Header from './Components/Header';
import Login from './Pages/Login';
import ForgotPassword from './Pages/ForgotPassword';
import AdminNav from './Navbar/AdminNav';
import AuthUser from './AuthUser';
import ResetPassword from './Pages/ResetPassword';
const App = () => { 
   const {getUsertype,getToken} = AuthUser();
   const usertype = getUsertype();
   if(!getToken()){
      return (
         <>
            <Header />
               <Routes>
                  <Route path="/" exact element={<Login/>}/> 
                  <Route path="/ForgotPassword" exact element={<ForgotPassword />}/> 
                  <Route path="/resetpassword/:token/:email" exact element={<ResetPassword />} />
               </Routes>
            <Footer />
         </>
      );
   }else{
      return (
         <>          
            <AdminNav />
            <Footer />
         </>
      );
   }
}
export default App;